import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('DesignResource')
export default class DesignResource {
  @JsonProperty('display_place_key')
  public displayPlaceKey = '';

  @JsonProperty('display_text')
  public displayText = '';

  @JsonProperty('css_class_name')
  public cssClassName = '';

  @JsonProperty('resource_uri')
  public resourceUri = '';

  @JsonProperty('resource_file_name')
  public resourceFileName = '';

  @JsonProperty('alternative_text')
  public alternativeText = '';
}
